module.exports = __webpack_public_path__ + "static/media/STACAN.082c6e75.jpg";